import React from "react";
import { displayFalsyValue, MetadataRenderer, sortMetadataEntries } from "./DisplayHelpers";

export default class RouteMetadataService {
    /**
     * A map for ordering route metadata keys by priority and display names.
     */
     static ROUTE_METADATA_DEFINITION_MAP = {
         endADevice: { displayName: "Start Device", priority: 1 },
         endZDevice: { displayName: "End Device", priority: 2 },
         linkId: { displayName: "Link ID", priority: 3 },
         deviceCount: { displayName: "Device Count", priority: 4 },
         hopCount: { displayName: "Hop Count", priority: 5 },
         typeId: { displayName: "Type ID", priority: 6 }
     };

     static processRouteMetadata(route) {
         if (!route) {
             return {
                 sortedMetadata: [],
                 renderableMetadata: []
             };
         }

         return RouteMetadataService
             .processSortedMetadata(route, RouteMetadataService.ROUTE_METADATA_DEFINITION_MAP);
     }

     /**
     * Using the route and the key configuration map, produce two lists:
     * one showing how the metadata should be ordered and one with the
     * JSX elements rendered in order.
     * @param route
     * @param keyConfigMap key: string, value: { displayName: string, priority: number }
     */
     static processSortedMetadata = (route, keyConfigMap) => {
         if (route.metadata) {
             const keyOrder = Object.keys(keyConfigMap);
             const sortedMetadata = sortMetadataEntries(route.metadata, keyOrder).map(
                 ([key, value]) => [key, displayFalsyValue(value)]
             );

             const renderableMetadata = sortedMetadata.map(([key, value]) => {
                 const config = keyConfigMap[key];
                 const displayName = config?.displayName || key;

                 return {
                     key,
                     displayName,
                     value,
                     renderedValue: <MetadataRenderer fieldName={key} value={value}/>
                 };
             });

             return { sortedMetadata, renderableMetadata };
         }
         return {
             sortedMetadata: [],
             renderableMetadata: []
         };
     };

     static hasMetadata(route, sortedMetadata) {
         return !!(route && route.metadata && sortedMetadata.length > 0);
     }

     static hasValidRoute(route) {
         return !!(route && route.hops);
     }
}